<template>
  <div>
    <h1>
        Video Call Demo<br><small style="font-size: 14pt">Powered by Agora.io</small>
    </h1>

    <p>App id : <input type="text" id="app-id" value=""></p>
    <p>Channel : <input type="text" id="channel" value=""></p>
    <p>Token : <input type="text" id="token" placeholder="(optional)" value=""></p>
    <button id="start">Start</button>
    <button id="stop" disabled>Stop</button>

    <h4>My Feed :</h4>
    <div id="me"></div>

    <h4>Remote Feeds :</h4>
    <div id="remote-container">

    </div>
  </div>
</template>

<script>
export default {
  name: 'myVideoCall',
  data () {
    return {
    // JS reference to the container where the remote feeds belong
      remoteContainer: document.getElementById('remote-container')
      // client : '',
    }
  },
  methods: {
    // Client Setup
    // Defines a client for RTC
    //  client = AgoraRTC.createClient({ mode: "rtc", codec: "vp8" }),

    /**
 * @name addVideoContainer
 * @param uid - uid of the user
 * @description Helper function to add the video stream to "remote-container".
 */
    addVideoContainer (uid) {
      const streamDiv = document.createElement('div') // Create a new div for every stream
      streamDiv.id = uid // Assigning id to div
      streamDiv.style.transform = 'rotateY(180deg)' // Takes care of lateral inversion (mirror image)
      this.remoteContainer.appendChild(streamDiv) // Add new div to container
    },
    /**
 * @name removeVideoContainer
 * @param uid - uid of the user
 * @description Helper function to remove the video stream from "remote-container".
 */
    removeVideoContainer (uid) {
      const remDiv = document.getElementById(uid)
      remDiv && remDiv.parentNode.removeChild(remDiv)
    }
  },
  mounted () {

  }
}
</script>

<style lang="scss" scoped>

h1,h4,p{
    text-align: center;
}
button{
    display: block;
    margin: 5px auto;
}
#remote-container video{
    height: auto;
    position: relative !important;
}
#me{
    position: relative;
    width: 50%;
    margin: 0 auto;
    display: block;
}
#me video{
    position: relative !important;
}
#remote-container{
    display: flex;
}
</style>
